<template>
    <div>
        <div class="title">
            <h4>订单管理</h4>
        </div>
        <!-- 搜索框 -->
        <div class="searchBox" ref="searchBox">
            <el-form :inline="true" :model="table.searchForm" ref="searchForm" class="demo-form-inline"
                label-width="100px" size="mini">
                <div class="inpBox">
                    <el-form-item label="订单状态 :" prop="marker">
                        <el-select v-model="table.searchForm.status" placeholder="请选择">
                            <el-option label="请选择" value=""></el-option>
                            <el-option label="待指派" value="0"></el-option>
                            <el-option label="待上门" value="1"></el-option>
                            <el-option label="服务中" value="2"></el-option>
                            <el-option label="已完成" value="3"></el-option>
                            <el-option label="已取消" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="searchBtnBox">
                    <el-form-item>
                        <el-button type="primary" @click="tableSearch">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="tableResetForm">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="RExportFn" :disabled="exportBtnDisable">导出</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="table" :style="{ height: table.height }">
            <el-table :data="table.tableList" ref="table" v-loading="table.loading" @row-click="tableHandleRowClick"
                highlight-current-row bordersize="mini" height="100%" style="width: 100%" center border >
                <el-table-column fixed type="index" width="50" label="序号"></el-table-column>
                <el-table-column label="操作" width="50">
                    <template slot-scope="scope">
                        <div>
                            <el-button v-if="scope.row.status === 0||scope.row.status === 1||scope.row.status === 2" type="text" size="mini"
                                @click="editDialogEdit(scope.row)">指派</el-button>
                            <el-button v-if="scope.row.status !== 0" type="text" size="mini"
                                @click="viewDialogWindow(scope.row)">查看</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" min-width="50">
                    <template scope="scope">
                        {{ ["待指派", "待上门", "服务中", "已完成", "已取消"][scope.row.status] }}
                    </template>
                </el-table-column>
                <el-table-column prop="code" min-width="50" label="预约码"></el-table-column>
                <el-table-column prop="repairPrice" min-width="50" label="付款金额"></el-table-column>
                <el-table-column prop="address" min-width="160" label="上门信息"
                    :show-overflow-tooltip="true" style="width: 160px;">
                    <template slot-scope="scope">
                        <p  style="text-align: left;color: #1894db;" >{{ scope.row.address }}</p>
                        <p style="text-align: left;">{{ scope.row.codeConfirmTime }}</p>  
                    </template>
                </el-table-column>
                <el-table-column prop="contact" min-width="70" label="客户姓名"></el-table-column>
                <el-table-column prop="phoneNum" min-width="90" label="客户手机"></el-table-column>
                <el-table-column prop="service.name" min-width="80" label="服务项目"></el-table-column>
                <el-table-column min-width="110" label="所属区域" prop="coordinateRegion"></el-table-column>
                <el-table-column prop="worker.idName" min-width="90" label="师傅信息" >
                    <template slot-scope="scope" v-if="scope.row.worker">
                        <p  style="text-align: left;color: #1894db;" >{{ scope.row.worker && scope.row.worker.idName ? scope.row.worker.idName : '' }}</p>
                        <p style="text-align: left;">{{ scope.row.branchName ? scope.row.branchName : '全国总店'}}</p>  
                    </template>
                </el-table-column>
                <el-table-column prop="worker.phoneNum" min-width="80" label="师傅手机"></el-table-column>
                <el-table-column prop="createdAt" min-width="80" label="下单时间"></el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination background @size-change="pagerHandleSizeChange" @current-change="pagerHandleCurrentChange"
                :current-page="table.searchForm.pageNo" :page-sizes="[10, 20, 50, 100]"
                :page-size="table.searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="table.total"> </el-pagination>
        </div>
        <!-- 新建或编辑弹窗 -->
        <el-dialog :title="editDialog.title" :close-on-click-modal="false" :close-on-press-escape="false" class="vehm"
            :visible.sync="editDialog.visible" @close="editDialogClose" @opened="editDialogOpen" width="1200px" center>
            <span>
                <el-form :inline="true" :rules="editDialog.rules" :model="editDialog.form" ref="editDialogForm"
                    class="demo-form-inline jiaoyan" size="mini">
                    <el-form-item label="状态:" prop="status" label-width="100px">
                        <el-select placeholder="请选择" v-model="editDialog.form.status">
                            <el-option v-for="item in editDialog.statusList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预约码:" prop="code" label-width="100px">
                        <el-input placeholder="" :readonly="true" v-model="editDialog.form.code"></el-input>
                    </el-form-item>
                    <el-form-item label="客户姓名:" prop="contact" label-width="100px">
                        <el-input placeholder="" :readonly="true" v-model="editDialog.form.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="客户手机:" prop="phoneNum" label-width="100px">
                        <el-input placeholder="" :readonly="true" v-model="editDialog.form.phoneNum"></el-input>
                    </el-form-item>
                    <el-form-item label="服务项目:" prop="serviceName" label-width="100px">
                        <el-input placeholder="" :readonly="true" v-model="editDialog.form.service.name"></el-input>
                    </el-form-item>
                    <el-form-item label="所属区域:" prop="coordinateRegion" label-width="100px">
                        <el-input placeholder="" :readonly="true" v-model="editDialog.form.coordinateRegion"></el-input>
                    </el-form-item>
                    <br>
                    <span style="color: red; margin-left: 25px;line-height: 25px;">*</span>
                    <el-form-item label="上门时间:" prop="serviceTime" class="service">
                        <el-date-picker v-model="editDialog.form.date" type="date" placeholder="选择日期"
                            :picker-options="pickerOptions"></el-date-picker>
                        <el-time-picker style="margin-left: 5px;" v-model="editDialog.form.time" format="HH:mm"
                            :picker-options="pickerOptions1" placeholder="选择时间">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="备注:" prop="remark" label-width="100px">
                        <el-input type="textarea" v-model="editDialog.form.remark"></el-input>
                    </el-form-item>
                </el-form>
            </span>
            <el-divider content-position="center">本店师傅</el-divider>
            <div>
                <div class="searchBox" ref="searchBox">
                    <el-form :inline="true" :model="tableWorker.searchForm" ref="searchWorkerForm"
                        class="demo-form-inline" label-width="100px" size="mini">
                        <div class="inpBox">
                            <el-form-item label="请选择门店:" prop="status" label-width="100px">
                                <el-select placeholder="请选择" v-model="tableWorker.searchForm.branchId">
                                    <el-option v-for="item in tableWorker.allBranches" :key="item.id"
                                        :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="手机号: " prop="phoneNum">
                                <el-input placeholder="" v-model="tableWorker.searchForm.phoneNum"></el-input>
                            </el-form-item> -->
                            <el-form-item>
                                <el-button type="primary" @click="tableWorkerSearch">查询</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="tableWorkerResetForm">重置</el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="table" style="height: 500px">
                    <el-table :data="tableWorker.tableList" ref="table" v-loading="tableWorker.loading"
                        @row-click="tableWorkerHandleRowClick" highlight-current-row bordersize="mini" height="100%"
                        style="width: 100%" center border>
                        <el-table-column prop="idName" min-width="80" label="姓名">
                            <template slot-scope="scope">
                                {{ scope.row.idName ? scope.row.idName : "暂未实名" }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="age" min-width="50" label="年龄">
                            <template slot-scope="scope">
                                {{ scope.row.age ? scope.row.age : "暂未实名" }}
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="idCode" min-width="120" label="身份证号">
                            <template slot-scope="scope">
                                {{ scope.row.idCode ? scope.row.idCode : "暂未实名" }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="idCode" min-width="120" label="所属门店">
                            <template slot-scope="scope">
                                {{ scope.row.branch && scope.row.branch.name ? scope.row.branch.name : '暂无' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="phoneNum" min-width="120" label="手机号"></el-table-column>
                    </el-table>
                </div>
                <div>
                    <el-pagination background @size-change="pagerHandleSizeChangeWorker"
                        @current-change="pagerHandleCurrentChangeWorker" :current-page="tableWorker.searchForm.pageNo"
                        :page-sizes="[10, 20, 50, 100]" :page-size="tableWorker.searchForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="tableWorker.total"> </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="editDialogSave">确认</el-button>
            </span>
        </el-dialog>
        <!-- 查看窗口 -->
        <el-dialog :title="viewDialog.title" :close-on-click-modal="false" :close-on-press-escape="false" class="vehm"
            :visible.sync="viewDialog.visible" @close="viewDialogClose" @opened="viewDialogOpen" width="1200px" center>
            <span>
                <el-form :inline="true" :rules="viewDialog.rules" :model="viewDialog.form" ref="viewDialogForm"
                    class="demo-form-inline jiaoyan" label-width="100px" size="mini">
                    <el-form-item label="状态:" prop="status">
                        <el-select placeholder="请选择" v-model="viewDialog.form.status">
                            <el-option v-for="item in viewDialog.statusList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预约码:" prop="code">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.code"></el-input>
                    </el-form-item>
                    <el-form-item label="客户姓名:" prop="contact">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="客户手机:" prop="phoneNum">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.phoneNum"></el-input>
                    </el-form-item>
                    <el-form-item label="服务项目:" prop="serviceName">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.service.name"></el-input>
                    </el-form-item>
                    <el-form-item label="所属区域:" prop="district">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.district"></el-input>
                    </el-form-item>
                    <el-form-item label="负责师傅:" prop="worker.idName">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.worker.idName"></el-input>
                    </el-form-item>
                    <el-form-item label="维修价格:" prop="worker.repairPrice">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.repairPrice"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="是否支付:" prop="worker.payStatusRepair">
                        <el-input readonly="1" placeholder="" v-model="viewDialog.form.payStatusRepair"></el-input>
                    </el-form-item> -->
                     <el-form-item label="取消原因:" prop="cancelReason" v-if="viewDialog.form.cancelReason">
                        <el-input :readonly="true" placeholder="" v-model="viewDialog.form.cancelReason"></el-input>
                    </el-form-item>
                    <br />
                    <el-form-item label="维修内容:" prop="repair">
                        <el-input placeholder="" style="height: 100px !important" type="textarea"
                            v-model="viewDialog.form.repair" :readonly="true"></el-input>
                    </el-form-item>
                    <div v-if="viewDialog.form.images">
                        <el-divider content-position="center">现场拍照</el-divider>

                        <div>
                            <a :href="i" target="_blank" v-for="(i, key) in viewDialog.form.images.top" :key="key">
                                <img :src="i" alt="" style="width: 100px; border: 1px solid #ccc; margin: 10px" />
                            </a>
                        </div>
                        <div>
                            <a :href="i" target="_blank" v-for="(i, key) in viewDialog.form.images.middle" :key="key">
                                <img :src="i" alt="" style="width: 100px; border: 1px solid #ccc; margin: 10px" />
                            </a>
                        </div>
                        <div>
                            <a :href="i" target="_blank" v-for="(i, key) in viewDialog.form.images.bottom" :key="key">
                                <img :src="i" alt="" style="width: 100px; border: 1px solid #ccc; margin: 10px" />
                            </a>
                        </div>
                    </div>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewDialog.visible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    /* eslint-disable */
    import { orderList, orderAssign, workerList, exportOrder,branchesList,searchWorkers } from "@/api/request";
    import { Message,Loading } from "element-ui";
    export default {
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {                 
                        return time.getTime() < Date.now()-8.64e7;     //禁止选取当天之后的日期（不包括静止当天）
                        //或者是：
                        //return time.getTime() > Date.now(); 		
                        //return time.getTime() > Date.now()- 8.64e7;     //禁止选取当天之后的日期（包括禁止当天）
                    },
                },
                pickerOptions1: {
                    selectableRange: '05:00:00 - 21:59:59'
                },
                exportBtnDisable: false,
                table: {
                    height: "500px",
                    loading: false,
                    total: 0,
                    tableList: [],
                    searchForm: {
                        pageNo: 1,
                        pageSize: 10,
                    },
                   
                },
                tableWorker: {
                    height: "500px",
                    loading: false,
                    total: 0,
                    searchForm: {
                        pageNo: 1,
                        pageSize: 10,
                        branchId:'',
                        status:0
                    },
                    allBranches:[],
                    branchId:'',
                },
                editDialog: {
                    title: "订单指派",
                    operation: "edit",
                    form: {
                        user: {},
                        service: {},
                        worker: {},
                        date:'',
                        time:''
                    },
                   
                    visible: false,
                    genderList: [
                        { value: 0, label: "男" },
                        { value: 1, label: "女" },
                        { value: 2, label: "保密" },
                    ],
                    statusList: [
                        { value: 0, label: "待指派" },
                        { value: 1, label: "待上门" },
                        { value: 2, label: "服务中" },
                        { value: 3, label: "已完成" },
                        { value: 4, label: "已取消" },
                    ],
                    roleList: [
                        { value: 1, label: "管理员1" },
                        { value: 2, label: "管理员2" },
                        { value: 3, label: "管理员3" },
                    ],
                    rules: {
                        // serviceTime: [{ required: true, message: "请填写上门时间", trigger: "blur" }],
                        // password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                        // name: [{ required: true, message: "请输入店名", trigger: "blur" }],
                        // district: [{ required: true, message: "请输入所属区域", trigger: "blur" }],
                        // worker: [{ required: true, message: "请选择要指派的师傅", trigger: "blur" }],
                    },
                },
                viewDialog: {
                    title: "查看订单",
                    form: {
                        user: {},
                        service: {},
                        worker: {},
                        
                    },
                    visible: false,
                    genderList: [
                        { value: 0, label: "男" },
                        { value: 1, label: "女" },
                        { value: 2, label: "保密" },
                    ],
                    statusList: [
                        { value: 0, label: "待指派" },
                        { value: 1, label: "待上门" },
                        { value: 2, label: "服务中" },
                        { value: 3, label: "已完成" },
                        { value: 4, label: "已取消" },
                    ],
                },
            };
        },
        created() {
            this.tableGetList(this.table.searchForm);
            
        },
        mounted() {},
        methods: {
            //获取所有门店
            branchesGetList(){
                branchesList().then(
                    (res) => {
                        console.log(res,'所有门店');
                        this.tableWorker.allBranches = res.data.list
                    },
                    (res) => {
                        Message({
                            message: `${res.message}`,
                            type: "error",
                            duration: 1500,
                        });
                    }
                )
            },
            //门店下工人列表查询
            getBranchWorker(){
                searchWorkers(this.tableWorker.searchForm).then(
                    (res)=>{
                        console.log(res);
                        this.tableWorker.total = res.data.total;
                        this.tableWorker.tableList = res.data.list;
                    },
                    (res) =>{
                        Message({
                            message: `${res.message}`,
                            type: "error",
                            duration: 1500,
                        });
                    }
                )
            },
            // 日期格式转化函数
            formatDate(date) {
                var year = date.getFullYear(); // 获取年份
                var month = date.getMonth() + 1; // 获取月份
                var day = date.getDate(); // 获取日期
                var hours = date.getHours(); // 获取小时
                var minutes = date.getMinutes(); // 获取分钟
                var seconds = date.getSeconds(); // 获取秒数

                // 格式化为指定的日期格式
                var formattedDate = year + "-" + this.addZero(month) + "-" + this.addZero(day) +""

                return formattedDate;
            },
            // 在个位数前添加零
            addZero(num) {
                return num < 10 ? "0" + num : num;
            },
            //时间格式转化函数
            formatTime(date) {
                var hours = date.getHours(); // 获取小时
                var minutes = date.getMinutes(); // 获取分钟
                var seconds = date.getSeconds(); // 获取秒数

                // 格式化为指定的日期格式
                var formatTime = this.addZero(hours) + ":" + this.addZero(minutes) + ":" + this.addZero(seconds);

                return formatTime;
            },
                RExportFn() {
                this.exportBtnDisable = true;
                setTimeout(() => {
                    this.exportBtnDisable = false;
                }, 5000);
                const downloadLoadingInstance = Loading.service({
                    text: "正在处理...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                exportOrder(this.table.searchForm).then(
                    (response) => {
                        console.log("response", response);
                        downloadLoadingInstance.close();
                        let blob = new Blob([response], {
                            type: "application/vnd.ms-excel",
                        });
                        let date = new Date();
                        let newTime = date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + date.getDate();
                        let fileName = "订单数据" + newTime + ".xls";
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName);
                        } else {
                            var link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = fileName;
                            link.click();
                            window.URL.revokeObjectURL(link.href); // 释放内存
                        }
                    },
                    (error) => {
                        downloadLoadingInstance.close();
                        console.log("error", error);
                    }
                );
            },
            // 编辑窗口: 关闭对话框后(渲染结束)执行. 恢复窗口初始状态
            editDialogClose() {
                this.$nextTick(() => {
                    this.editDialog.form = { user: {}, service: {}, worker: {} };
                    this.editDialog.operation = "edit";
                    this.$refs.editDialogForm.clearValidate();
                    this.tableWorker.searchForm={
                        pageNo: 1,
                        pageSize: 10,
                        branchId:''
                    }

                });
            },
            // 编辑窗口: 打开. 通用设置
            editDialogOpen() {
                this.editDialog.visible = true;
                this.editDialog.form.serviceTime=''
            },
            // 编辑窗口: 关闭对话框后(渲染结束)执行. 恢复窗口初始状态
            viewDialogClose() {
                this.$nextTick(() => {
                    this.tableWorker.searchForm.branchId=''
                    this.viewDialog.form = { user: {}, service: {}, worker: {} };
                    this.$refs.viewDialogForm.clearValidate();
                });
            },
            // 编辑窗口: 打开. 通用设置
            viewDialogOpen() {
                this.viewDialog.visible = true;
            },
            viewDialogWindow(row) {
                if (row.user == null) row.user = {};
                if (row.service == null) row.service = {};
                if (row.worker == null) row.worker = {};
                this.viewDialog.visible = true;
                this.viewDialog.form = row;
                this.viewDialog.form.images = JSON.parse(this.viewDialog.form.images);
                // console.log(this.viewDialog.form);
            },
            // 编辑窗口: 编辑. 同时触发editDialogOpen()
            editDialogEdit(row) {
                // console.log(row);
                if (row.user == null) row.user = {};
                if (row.service == null) row.service = {};
                if (row.worker == null) row.worker = {};
                this.editDialog.visible = true;
                this.editDialog.operation = "edit";
                this.editDialog.form = row;
                console.log("open...");
                this.branchesGetList()
                this.getBranchWorker(this.tableWorker.searchForm)
            },
            editDialogDelete(row) {},
            editDialogSave() {
                this.$refs.editDialogForm.validate((valid) => {
                    if(!this.editDialog.form.date || !this.editDialog.form.time){
                        Message({
                            message: '请选择上门时间',
                            duration: 800,
                        });
                    }else{
                        if (valid) {
                        // 全屏遮罩. 不是表格遮罩
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        if (this.editDialog.operation == "add") {
                            console.log(123);
                            workerAdd(this.editDialog.form)
                                .then(
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "success",
                                            duration: 800,
                                            onClose: () => {
                                                console.log("res", res);
                                                loading.close();
                                                this.editDialog.visible = false;
                                                this.tableGetList(this.table.searchForm);
                                            },
                                        });
                                    },
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                        });
                                    }
                                )
                                .catch((error) => {
                                    console.log(error);
                                });
                        } else if (this.editDialog.operation == "edit") {
                            console.log(this.editDialog.form,44444);
                            const {serviceTime,date,time,...newObj} =this.editDialog.form
                            let arr = [this.formatDate(this.editDialog.form.date),this.formatTime(this.editDialog.form.time)]
                            let serviceTimes = arr.join(' ')
                            console.log(serviceTimes);
                            newObj['serviceTime'] = serviceTimes
                            newObj['branchId'] = this.tableWorker.branchId 
                            console.log(newObj);
                            orderAssign(newObj)
                                .then(
                                    (res) => {
                                        if(res.code === 0){
                                            Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                         });
                                        }else{
                                            Message({
                                            message: `${res.message}`,
                                            type: "success",
                                            duration: 800,
                                            onClose: () => {
                                                console.log("res", res);
                                                loading.close();
                                                this.editDialog.visible = false;
                                                this.tableGetList(this.table.searchForm);
                                            },
                                        });
                                        }
                                        
                                       
                                    },
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                         });
                                    }
                                )
                                .catch((error) => {
                                    this.$message({
                                        showClose: true,
                                        message: error instanceof Object && error.message !== undefined ? error.message : "Cannot parse response",
                                        type: "error",
                                        onClose() {},
                                    });
                                });
                        }
                    }
                    }
                    
                });
            },
            editStatus(row, value) {
                const loading = this.$loading({
                    lock: true,
                    text: "正在处理...",
                });
                workerEdit({ ...row, status: value }).then(
                    (res) => {
                        console.log("res", res);
                        loading.close();
                        this.tableGetList(this.table.searchForm);
                    },
                    (res) => {
                        Message({
                            message: res.message,
                            type: "error",
                            duration: 1500,
                            onClose: () => {
                                loading.close();
                            },
                        });
                    }
                );
            },
            workerDelete(row) {
                this.$confirm("确定进行删除操作吗?", "Tips", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                }).then(
                    () => {
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        workerDelete(row).then(
                            (res) => {
                                loading.close();
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                });
                                this.tableGetList(this.table.searchForm);
                            },
                            (res) => {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "error",
                                    onClose() {
                                        loading.close();
                                    },
                                });
                            }
                        );
                    },
                    () => {}
                );
            },
            // 表格: 列表查询方法
            tableGetList(searchForm) {
                orderList(searchForm.createTime ? { ...searchForm, createTime: `${searchForm.createTime[0]},${searchForm.createTime[1]}` } : { ...searchForm })
                    .then(
                        (res) => {
                            this.table.total = res.data.total;
                            this.table.tableList = res.data.list;
                            console.log("this.table.tableList", this.table.tableList);
                        },
                        (res) => {
                            Message({
                                message: `${res.message}`,
                                type: "error",
                                duration: 1500,
                            });
                        }
                    )
                    .catch((error) => {
                        Message({
                            message: `${error}`,
                            type: "error",
                            duration: 1500,
                        });
                    });
            },
            // 表格: 点击重置搜索条件时
            tableResetForm() {
                this.table.searchForm = {
                    pageNo: 1,
                    pageSize: 10,
                };
                this.tableGetList(this.table.searchForm);
            },
            tableWorkerResetForm() {
                this.tableWorker.searchForm = {
                    pageNo: 1,
                    pageSize: 10,
                };
                this.getBranchWorker(this.tableWorker.searchForm)
            },
            // 表格: 点击表格的行时
            tableHandleRowClick(row, column, event) {
                this.$refs.table.toggleRowSelection(row);
            },
            // 表格: 点击搜索按钮时
            tableSearch() {
                console.log(this.table.searchForm);
                this.tableGetList(this.table.searchForm);
            },
            tableWorkerSearch() {
                console.log(this.tableWorker.searchForm);
                this.getBranchWorker(this.tableWorker.searchForm);
            },
            tableWorkerHandleRowClick(row, column, event) {
                console.log(row);
                this.$set(this.editDialog.form.worker, "idName", row.idName);
                this.$set(this.editDialog.form.worker, "phoneNum", row.phoneNum);
                this.editDialog.form.workerRId = row.id;
                this.tableWorker.branchId = row.branchId;
                console.log(this.editDialog.form);
            },
            // 表格: 列表查询方法
            tableWorkerGetList(searchForm) {
                workerList(searchForm)
                    .then(
                        (res) => {
                            this.tableWorker.total = res.data.total;
                            this.tableWorker.tableList = res.data.list;
                            console.log("this.table.tableList", this.table.tableList);
                        },
                        (res) => {
                            Message({
                                message: `${res.message}`,
                                type: "error",
                                duration: 1500,
                            });
                        }
                    )
                    .catch((error) => {
                        Message({
                            message: `${error}`,
                            type: "error",
                            duration: 1500,
                        });
                    });
            },
            // 分页器: 每页条数发生变化时
            pagerHandleSizeChange(val) {
                this.table.searchForm.pageSize = val;
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 翻页时
            pagerHandleCurrentChange(val) {
                this.table.searchForm.pageNo = val;
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 每页条数发生变化时
            pagerHandleSizeChangeWorker(val) {
                this.tableWorker.searchForm.pageSize = val;
                this.tableWorkerGetList(this.tableWorker.searchForm);
            },
            // 分页器: 翻页时
            pagerHandleCurrentChangeWorker(val) {
                this.tableWorker.searchForm.pageNo = val;
                this.tableWorkerGetList(this.tableWorker.searchForm);
            },
        },
    };
</script>
<style lang="scss" scoped>
    .title {
        display: flex;
        justify-content: space-between;
        padding-right: 10px 10px;
        margin-left: 10px;
        border-bottom: 1px solid #dcdfe6;
        margin-bottom: 10px;
        h4 {
            margin: 0;
            font-size: 14px;
            color: #333;
            padding-bottom: 10px;
            border-bottom: 2px solid rgb(166, 59, 58);
        }
    }
    .searchBox {
        display: flex;
        .searchBtnBox {
            padding-left: 10px;
            // margin-left: 10px;
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
        }
        .inpBox {
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
            ::v-deep .el-form-item.long {
                width: 100%;
                margin-right: 0 !important;
            }
            ::v-deep .el-date-editor {
                width: 350px !important;
            }
        }
    }
    .table {
        ::v-deep .el-table {
            color: #333;
            th {
                background-color: #f5f5f5;
                height: 40px;
                color: #333333 !important;
                padding: 2px 0 !important;
                &:first-child .cell {
                    padding: 0 10px 0 10px;
                }
            }
            tr {
                height: 32px;
                &:nth-child(even) {
                    background-color: #f8fafd;
                }
            }
            td {
                padding: 2px 0 !important;
            }
            .cell {
                text-align: center;
                padding: 0 10px;
            }
            .el-button--primary {
                background-color: rgb(166, 59, 58);
            }
            .el-button--primary:focus,
            .el-button--primary:hover {
                background: rgb(166, 59, 58);
                border-color: rgb(166, 59, 58);
                color: #fff;
            }
            .el-button {
                padding: 7px 15px;
            }
            .el-button--text {
                padding: 0;
            }
            .bigBtn {
                padding: 12px 28px;
            }
            .el-button--text {
                color: rgb(24, 148, 219);
            }
            .el-button--text:focus,
            .el-button--text:hover {
                color: rgb(24, 148, 219);
            }
            .el-table__body tr.hover-row > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
            .el-table__body tr.current-row > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
            .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
        }
    }
    .el-dialog__wrapper {
        ::v-deep .el-dialog__header {
           
            background-color: rgb(166, 59, 58);
            .el-dialog__title {
                color: #fff;
            }
            .el-dialog__headerbtn {
                top: 12px;
                .el-dialog__close {
                    color: #fff;
                }
            }
        }
        // ::v-deep .el-input__inner,
        // ::v-deep .el-textarea__inner {
            
        //     width: 150px !important;
        // }
        ::v-deep .el-textarea__inner {
            width: 300px !important;
            height: 100px;
            margin-bottom: 0 !important;
        }
        .hidden ::v-deep .el-upload--picture-card {
            display: none;
        }
        .addressBox .title {
            margin-top: 0;
            margin-left: 10px;
            font-size: 14px;
            margin-bottom: 20px;
            .iconFont {
                color: rgb(166, 59, 58);
                margin-right: 4px;
                font-size: 14px;
            }
        }
        ::v-deep .el-upload--picture-card {
            background-image: url("../../assets/images/upload.png");
            background-size: 150%;
            background-position: 50% 50%;
        }
    }
    ::v-deep .el-pagination.is-background .el-pager li {
        margin: 0 5px !important;
    }
    //  ::v-deep .service .el-textarea__inner {
    //         width: 173px !important;
    //     }
        
// .tableLimit tr td .cell{
//    overflow : hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
// //   -webkit-line-clamp: 2;      /*可以显示的行数，超出部分用...表示 */
// //   -webkit-box-orient: vertical; 
 
// }
</style>
